export default {
    HOME_GENERATE(state, home) {
        state.items = home;
    }
}